export class RepresentativeModel {
  firstName = "";
  lastName = "";
  email = "";
  phoneNumber = "";
  department = "";
}
